import { Link } from 'react-router-dom';
import styled from 'styled-components';

const BaseText = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
  line-height: 16px;

  a {
    color: #CB3D42;
    text-decoration: none;
    font-weight: bold;
  }
`;

export const SupportText = () => {
  return (
    <BaseText>
      Não lembra da sua conta? <Link to="/register" rel="" target="_blank">Cadastre-se aqui</Link> <br/>
      Ou recupere sua conta através do <a href="mailto:faleconosco@zonasul.com.br" rel="noreferrer" target="_blank">Suporte</a>
    </BaseText>
  )
};
